// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/young-serif-v2-latin_latin-ext-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/outfit-v11-latin_latin-ext-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/outfit-v11-latin_latin-ext-600.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/outfit-v11-latin_latin-ext-700.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* young-serif-regular - latin_latin-ext */
@font-face {
    font-display: swap;
    /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Young Serif';
    font-style: normal;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
    /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}

/* outfit-regular - latin_latin-ext */
@font-face {
    font-display: swap;
    /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Outfit';
    font-style: normal;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
    /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}

/* outfit-600 - latin_latin-ext */
@font-face {
    font-display: swap;
    /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Outfit';
    font-style: normal;
    font-weight: 600;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
    /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}

/* outfit-700 - latin_latin-ext */
@font-face {
    font-display: swap;
    /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Outfit';
    font-style: normal;
    font-weight: 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2');
    /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}

/* Box sizing rules */
*,
*::before,
*::after {
    box-sizing: border-box;
}

/* Prevent font size inflation */
html {
    -moz-text-size-adjust: none;
    -webkit-text-size-adjust: none;
    text-size-adjust: none;
}

/* Remove default margin in favour of better control in authored CSS */
body,
h1,
h2,
h3,
h4,
p,
figure,
blockquote,
dl,
dd {
    margin-block-end: 0;
}

/* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
ul[role='list'],
ol[role='list'] {
    list-style: none;
}

/* Set core body defaults */
body {
    min-height: 100vh;
    line-height: 1.5;
}

/* Set shorter line heights on headings and interactive elements */
h1,
h2,
h3,
h4,
button,
input,
label {
    line-height: 1.1;
}

/* Balance text wrapping on headings */
h1,
h2,
h3,
h4 {
    text-wrap: balance;
}

/* A elements that don't have a class get default styles */
a:not([class]) {
    text-decoration-skip-ink: auto;
    color: currentColor;
}

/* Make images easier to work with */
img,
picture {
    max-width: 100%;
    display: block;
}

/* Inherit fonts for inputs and buttons */
input,
button,
textarea,
select {
    font-family: inherit;
    font-size: inherit;
}

/* Make sure textareas without a rows attribute are not tiny */
textarea:not([rows]) {
    min-height: 10em;
}

/* Anything that has been anchored to should have extra scroll margin */
:target {
    scroll-margin-block: 5ex;
}

/* end andy bell's reset */

:root {
    --clr-white: hsl(0, 0%, 100%);
    --clr-stone-100: hsl(30, 54%, 90%);
    --clr-stone-150: hsl(30, 18%, 87%);
    --clr-stone-600: hsl(30, 10%, 34%);
    --clr-stone-900: hsl(24, 5%, 18%);
    --clr-brown-800: hsl(14, 45%, 36%);
    --clr-rose-800: hsl(332, 51%, 32%);
    --clr-rose-50: hsl(330, 100%, 98%);
}

body {
    margin: 0;
    font-family: 'Outfit';
    color: var(--clr-stone-900);
    background-color: var(--clr-stone-100);
    display: flex;
    flex-direction: column;
    align-items: center;
}

main {
    width: min(100%, 46rem);
    background-color: var(--clr-white);
    border-radius: 16px;
}

.wrapper {
    padding: 1rem 2rem 0;
}

section {
    padding-bottom: 1rem;
}

section:not(:last-child) {
    border-bottom: 1px solid var(--clr-stone-100);
}

h1,
h2 {
    font-family: "Young Serif";
    text-wrap: unset;
}

h1 {
    margin-bottom: 1.5rem;
    letter-spacing: 2.5px;
}

h2 {
    font-size: 1.7rem;
    margin: 1em 0 0.8em;
    font-weight: 400;
    color: var(--clr-brown-800);
}

section.accent {
    margin-top: 1.4rem;
    padding: 1rem 1.5rem;
    background-color: var(--clr-rose-50);
    border-bottom: 0;
    border-radius: 8px;
}

.accent>h2 {
    margin: 0;
    font-family: 'Outfit';
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--clr-rose-800);
}

ul, ol {
    padding: 0 1.5rem 0.5rem;
    margin: 0;
    margin-top: 1rem;
}

ul>li,
ol>li {
    padding: 0 0 0.5rem 1rem;
}

ol>li::marker {
    font-weight: bold;
    color: var(--clr-brown-800);
}

table {
    margin-top: 1rem;
    table-layout: fixed;
    width: 100%;
    border-collapse: collapse;
}

td {
    padding: 0.75rem 2rem;
}

tr:not(:last-child) {
    border-bottom: 1px solid var(--clr-stone-100);
}

.accent-table {
    padding-left: 0.3rem;
    font-weight: bold;
    color: var(--clr-brown-800);
}

footer {
    padding-top: 2rem;
    text-align: center;
}

@media screen and (min-width: 768px) {

    body {
        padding-top: 8rem;
    }

    main {
        padding: 2.5rem 1rem;
    }

    h1 {
        font-size: 2.5rem;
        letter-spacing: unset;
    }

    img {
        width: min(100%, 650px);
        margin: 0 auto;
        border-radius: 16px;
    }

    .accent {
        margin-top: 2.5rem;
    }
    
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;IACI,kBAAkB;IAClB,sGAAsG;IACtG,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,4DAAgF;IAChF,4DAA4D;AAChE;;AAEA,qCAAqC;AACrC;IACI,kBAAkB;IAClB,sGAAsG;IACtG,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,4DAA4E;IAC5E,4DAA4D;AAChE;;AAEA,iCAAiC;AACjC;IACI,kBAAkB;IAClB,sGAAsG;IACtG,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,4DAAwE;IACxE,4DAA4D;AAChE;;AAEA,iCAAiC;AACjC;IACI,kBAAkB;IAClB,sGAAsG;IACtG,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,4DAAwE;IACxE,4DAA4D;AAChE;;AAEA,qBAAqB;AACrB;;;IAGI,sBAAsB;AAC1B;;AAEA,gCAAgC;AAChC;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA,sEAAsE;AACtE;;;;;;;;;;IAUI,mBAAmB;AACvB;;AAEA,2GAA2G;AAC3G;;IAEI,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,kEAAkE;AAClE;;;;;;;IAOI,gBAAgB;AACpB;;AAEA,sCAAsC;AACtC;;;;IAII,kBAAkB;AACtB;;AAEA,0DAA0D;AAC1D;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA,oCAAoC;AACpC;;IAEI,eAAe;IACf,cAAc;AAClB;;AAEA,yCAAyC;AACzC;;;;IAII,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA,8DAA8D;AAC9D;IACI,gBAAgB;AACpB;;AAEA,uEAAuE;AACvE;IACI,wBAAwB;AAC5B;;AAEA,0BAA0B;;AAE1B;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,kCAAkC;IAClC,kCAAkC;IAClC,iCAAiC;IACjC,kCAAkC;IAClC,kCAAkC;IAClC,kCAAkC;AACtC;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,2BAA2B;IAC3B,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;;IAEI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,SAAS;IACT,gBAAgB;AACpB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI;QACI,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;QACjB,qBAAqB;IACzB;;IAEA;QACI,uBAAuB;QACvB,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;AAEJ","sourcesContent":["/* young-serif-regular - latin_latin-ext */\r\n@font-face {\r\n    font-display: swap;\r\n    /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\r\n    font-family: 'Young Serif';\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    src: url('./fonts/young-serif-v2-latin_latin-ext-regular.woff2') format('woff2');\r\n    /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\r\n}\r\n\r\n/* outfit-regular - latin_latin-ext */\r\n@font-face {\r\n    font-display: swap;\r\n    /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\r\n    font-family: 'Outfit';\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    src: url('./fonts/outfit-v11-latin_latin-ext-regular.woff2') format('woff2');\r\n    /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\r\n}\r\n\r\n/* outfit-600 - latin_latin-ext */\r\n@font-face {\r\n    font-display: swap;\r\n    /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\r\n    font-family: 'Outfit';\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    src: url('./fonts/outfit-v11-latin_latin-ext-600.woff2') format('woff2');\r\n    /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\r\n}\r\n\r\n/* outfit-700 - latin_latin-ext */\r\n@font-face {\r\n    font-display: swap;\r\n    /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\r\n    font-family: 'Outfit';\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    src: url('./fonts/outfit-v11-latin_latin-ext-700.woff2') format('woff2');\r\n    /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\r\n}\r\n\r\n/* Box sizing rules */\r\n*,\r\n*::before,\r\n*::after {\r\n    box-sizing: border-box;\r\n}\r\n\r\n/* Prevent font size inflation */\r\nhtml {\r\n    -moz-text-size-adjust: none;\r\n    -webkit-text-size-adjust: none;\r\n    text-size-adjust: none;\r\n}\r\n\r\n/* Remove default margin in favour of better control in authored CSS */\r\nbody,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\np,\r\nfigure,\r\nblockquote,\r\ndl,\r\ndd {\r\n    margin-block-end: 0;\r\n}\r\n\r\n/* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */\r\nul[role='list'],\r\nol[role='list'] {\r\n    list-style: none;\r\n}\r\n\r\n/* Set core body defaults */\r\nbody {\r\n    min-height: 100vh;\r\n    line-height: 1.5;\r\n}\r\n\r\n/* Set shorter line heights on headings and interactive elements */\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nbutton,\r\ninput,\r\nlabel {\r\n    line-height: 1.1;\r\n}\r\n\r\n/* Balance text wrapping on headings */\r\nh1,\r\nh2,\r\nh3,\r\nh4 {\r\n    text-wrap: balance;\r\n}\r\n\r\n/* A elements that don't have a class get default styles */\r\na:not([class]) {\r\n    text-decoration-skip-ink: auto;\r\n    color: currentColor;\r\n}\r\n\r\n/* Make images easier to work with */\r\nimg,\r\npicture {\r\n    max-width: 100%;\r\n    display: block;\r\n}\r\n\r\n/* Inherit fonts for inputs and buttons */\r\ninput,\r\nbutton,\r\ntextarea,\r\nselect {\r\n    font-family: inherit;\r\n    font-size: inherit;\r\n}\r\n\r\n/* Make sure textareas without a rows attribute are not tiny */\r\ntextarea:not([rows]) {\r\n    min-height: 10em;\r\n}\r\n\r\n/* Anything that has been anchored to should have extra scroll margin */\r\n:target {\r\n    scroll-margin-block: 5ex;\r\n}\r\n\r\n/* end andy bell's reset */\r\n\r\n:root {\r\n    --clr-white: hsl(0, 0%, 100%);\r\n    --clr-stone-100: hsl(30, 54%, 90%);\r\n    --clr-stone-150: hsl(30, 18%, 87%);\r\n    --clr-stone-600: hsl(30, 10%, 34%);\r\n    --clr-stone-900: hsl(24, 5%, 18%);\r\n    --clr-brown-800: hsl(14, 45%, 36%);\r\n    --clr-rose-800: hsl(332, 51%, 32%);\r\n    --clr-rose-50: hsl(330, 100%, 98%);\r\n}\r\n\r\nbody {\r\n    margin: 0;\r\n    font-family: 'Outfit';\r\n    color: var(--clr-stone-900);\r\n    background-color: var(--clr-stone-100);\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n}\r\n\r\nmain {\r\n    width: min(100%, 46rem);\r\n    background-color: var(--clr-white);\r\n    border-radius: 16px;\r\n}\r\n\r\n.wrapper {\r\n    padding: 1rem 2rem 0;\r\n}\r\n\r\nsection {\r\n    padding-bottom: 1rem;\r\n}\r\n\r\nsection:not(:last-child) {\r\n    border-bottom: 1px solid var(--clr-stone-100);\r\n}\r\n\r\nh1,\r\nh2 {\r\n    font-family: \"Young Serif\";\r\n    text-wrap: unset;\r\n}\r\n\r\nh1 {\r\n    margin-bottom: 1.5rem;\r\n    letter-spacing: 2.5px;\r\n}\r\n\r\nh2 {\r\n    font-size: 1.7rem;\r\n    margin: 1em 0 0.8em;\r\n    font-weight: 400;\r\n    color: var(--clr-brown-800);\r\n}\r\n\r\nsection.accent {\r\n    margin-top: 1.4rem;\r\n    padding: 1rem 1.5rem;\r\n    background-color: var(--clr-rose-50);\r\n    border-bottom: 0;\r\n    border-radius: 8px;\r\n}\r\n\r\n.accent>h2 {\r\n    margin: 0;\r\n    font-family: 'Outfit';\r\n    font-size: 1.2rem;\r\n    font-weight: 600;\r\n    color: var(--clr-rose-800);\r\n}\r\n\r\nul, ol {\r\n    padding: 0 1.5rem 0.5rem;\r\n    margin: 0;\r\n    margin-top: 1rem;\r\n}\r\n\r\nul>li,\r\nol>li {\r\n    padding: 0 0 0.5rem 1rem;\r\n}\r\n\r\nol>li::marker {\r\n    font-weight: bold;\r\n    color: var(--clr-brown-800);\r\n}\r\n\r\ntable {\r\n    margin-top: 1rem;\r\n    table-layout: fixed;\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n\r\ntd {\r\n    padding: 0.75rem 2rem;\r\n}\r\n\r\ntr:not(:last-child) {\r\n    border-bottom: 1px solid var(--clr-stone-100);\r\n}\r\n\r\n.accent-table {\r\n    padding-left: 0.3rem;\r\n    font-weight: bold;\r\n    color: var(--clr-brown-800);\r\n}\r\n\r\nfooter {\r\n    padding-top: 2rem;\r\n    text-align: center;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n\r\n    body {\r\n        padding-top: 8rem;\r\n    }\r\n\r\n    main {\r\n        padding: 2.5rem 1rem;\r\n    }\r\n\r\n    h1 {\r\n        font-size: 2.5rem;\r\n        letter-spacing: unset;\r\n    }\r\n\r\n    img {\r\n        width: min(100%, 650px);\r\n        margin: 0 auto;\r\n        border-radius: 16px;\r\n    }\r\n\r\n    .accent {\r\n        margin-top: 2.5rem;\r\n    }\r\n    \r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
